module.exports = __webpack_public_path__ + "static/media/suspension_mini.f59850c6.png";